import { useEffect, useState } from 'react';
import { Box, SxProps, Theme } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { useNavigate } from 'react-router';
import {
  MessageCard,
  MessageBarStandalone,
  useCareTeamSlaStatus,
  messageNavigationState,
  useMessageStandaloneDisplayConfig,
} from '@xolv-mybrightlink/mybrightlink';
import { Routes } from '@xolv-mybrightlink/common';

export const MessageAction = (props: { sx?: SxProps<Theme> }) => {
  const slaAccepted = useCareTeamSlaStatus();
  const location = useLocation();
  const [messageBoxVisible, setMessageBoxVisible] = useState(true);
  const navigate = useNavigate();

  const { displayConfig, displayConfigDispatch } =
    useMessageStandaloneDisplayConfig();
  const isMessageBarDisplayed = displayConfig.visible;
  const toggle = () => {
    displayConfigDispatch({
      type: 'TOGGLE_VISIBLE',
    });
  };

  useEffect(() => {
    const isMessageRoute = location.pathname.startsWith(Routes.messages.index);
    setMessageBoxVisible(!isMessageRoute);
  }, [location]);

  useEffect(() => {
    if (isMessageBarDisplayed && !slaAccepted) {
      displayConfigDispatch({
        type: 'TOGGLE_VISIBLE',
      });
      messageNavigationState.collapsedPath = location.pathname;
      navigate(Routes.messages.careTeam.sla);
    }
  }, [
    isMessageBarDisplayed,
    displayConfigDispatch,
    slaAccepted,
    navigate,
    location,
  ]);

  if (!messageBoxVisible) {
    return null;
  }

  return (
    <Box
      className='hide-scrollbar'
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-end',
        flex: 1,
        position: 'fixed',
        right: 40,
        top: 0,
        mt: 10,
        px: 2.5,
        width: isMessageBarDisplayed ? 370 : 'unset',
        zIndex: 999,
        height: isMessageBarDisplayed ? 'calc(100% - 40px)' : 'auto',
        overflow: 'auto',
        ...props.sx,
      }}
    >
      <MessageCard onClick={toggle} open={isMessageBarDisplayed} />
      {isMessageBarDisplayed && slaAccepted && <MessageBarStandalone />}
    </Box>
  );
};
